var map = {
	"./courseData/courseCenter.data.js": "0f17",
	"./emerCase/emerCase.data.js": "1528",
	"./gpt/gpt.data.js": "700b",
	"./kbase/kbase.data.js": "a501",
	"./task.data.js": "ad87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb08";